import gql from 'graphql-tag';

export const fragmentTicketTypeMenuItem = gql`
    fragment TicketTypeMenuItem on TicketType {
        id
        title
    }
`;
export const getAllTopDepartment = gql`
  query allTopDepartment {
    allTopDepartment {
      ...topDepartment
      departments {
        ...department
        business {
          ...business
          ticket_types {
            ...TicketTypeMenuItem
          }
        }
      }
    }
  }
  ${fragmentTicketTypeMenuItem}

  fragment business on Business {
    id
    title
  }

  fragment department on Department {
    id
    title
  }

  fragment topDepartment on Department {
    id
    title
    name
    description
  }
`;

export const fragmentTicketTypeInfo = gql`
  fragment ticketTypeInfo on TicketType {
    id
    name
    title
    description
    type
  }
`

export const fragmentField = gql`
  fragment fieldFrag on Field {
    id
    name
    title
    display
    data_type
    default
  }
`

export const fragmentGroupField = gql`
  fragment groupField on GroupField {
    id
    name
    title
    type
    fields {
        ...fieldFrag
    }
  }
`
export const ticketType = gql`
  query ticketType($id: ID!){
      ticketType(id:$id){
        ...ticketTypeInfo
        common_fields {
            ...groupField
        }
        general_fields {
            ...groupField
        }
        specific_fields {
            ...groupField
        }
      }
  }
  ${fragmentTicketTypeInfo}
  ${fragmentGroupField}
  ${fragmentField}
`;

export const getUser = gql`
  query getUser($id: ID!){
    getUser(id: $id){
      id
      name
      fullname
      email
      endday
      role
      medias {
        _id
        id
        name
        scoin
      }
      historiesPucharseMedia {
        media {
          id
          name
          nations {
            name
          }
          kinds {
            name
          }
          languages {
            name
          }
        }
        created_date
      }
      historiesPucharseDay {
        package_purchase_day {
          day
          scoin
        }
        created_date
      }
      historyPackageDetail {
        package {
          id
          title
        }
        package_detail {
          id
          title
          day
          scoin
        }
        created_date
      }
      is_vip
      user_package {
        id
        endday
        package {
          id
          title
        }
      }
    }
  }
`;

export const updateUser = gql`
  mutation updateUser($userInput: UserInput!) {
    updateUser(input: $userInput) {
      id
      name
      fullname
      email
      endday
      role
      medias {
        _id
        id
        name
        scoin
      }
      historiesPucharseMedia {
        media {
          id
          name
          nations {
            name
          }
          kinds {
            name
          }
          languages {
            name
          }
        }
        created_date
      }
      historiesPucharseDay {
        package_purchase_day {
          day
          scoin
        }
        created_date
      }
      historyPackageDetail {
        package {
          id
          title
        }
        package_detail {
          id
          title
          day
          scoin
        }
        created_date
      }
      is_vip
      user_package {
        id
        endday
        package {
          id
          title
        }
      }
    }
  }
`;

export const getSliders = gql`
  query getSliders($type: Int, $home_slider_mode: Boolean){
    getSliderItems(type: $type, home_slider_mode: $home_slider_mode){
      id
      name
      sub_name
      slider
      img
    }
  }
`;
export const getMedia = gql`
  query getMedia($id: ID!, $user_id: Int) {
    getMedia(id:$id, user_id: $user_id) {
      id
      name
      type
      img
      url
      name
      nations {
        name
      }
      kinds {
        name
      }
      languages {
        name
      }
      scoreImdb
      type
      img
      scoin
      episodes {
        id
        title
        url
        description
        img
      }
      content
      type_purchase
      packages {
        id
        title
      }
      is_allow
  }
}`;

export const getMediaVietId = gql`
  query getMediaVietId($id: ID!, $viet_id: Int) {
    getMediaVietId(id:$id, viet_id: $viet_id) {
      id
      name
      type
      img
      url
      name
      nations {
        name
      }
      kinds {
        name
      }
      languages {
        name
      }
      scoreImdb
      type
      img
      scoin
      episodes {
        id
        title
        url
        description
        img
      }
      content
      type_purchase
      packages {
        id
        title
      }
      is_allow
  }
}`;

export const partners = gql`
  query partners {
    partners {
      id
      name
      logo
      url
    }
  }
`;


export const getAllContentMedia = gql`
  query getContentMediaHome {
    getContentMediaHome {
      id
      name
      sub_name

      nations {
        _id
        id
        name
        created_date
        updated_date
      }

      languages {
        _id
        id
        name
        created_date
        updated_date
      }

      categories {
        id
        _id
        name
        type
        genre
        created_date
        updated_date
      }

      kinds {
        _id
        id
        name
        created_date
        updated_date
      }

      type
      episodesCurent
      episodesMax
      scoreImdb
      img
      created_date
      updated_date
      category_ids
    	kind_ids
      nation_ids
      language_ids
  }
  }
`;
export const getListVideo = gql`
    query getListVideo($type: Int, $channels: ID, $limit: Int){
        getListVideo (type: $type, channels: $channels, limit: $limit){
            name
            img
            created_date
        }
    }
`;
export const getMediaRelationship = gql`
query getMediaRelationship($id: ID!, $type: Int, $limit: Int){
    getMediaRelationship(id: $id, type: $type, limit: $limit) {
      id
      name
      img
      url
      name
      scoreImdb
      img
    }
  }
`;

export const SearchQ = gql`
  query Search($name: String){
    Search(name:$name){
              name
              type
              id
            }
  }
`;
export const SportQ = gql`
  query Sport($type: ID!){
    getSportMediasByTypeCategories(type:$type){
              name
              id
              _id
              slug
              medias{
                id
                name
                img
                sub_name
                scoreImdb
                episodesCurent
                episodesMax
                kind_ids
                kinds {
                  _id
                  id
                  name
                  created_date
                  updated_date
                }
                nation_ids
                nations {
                  _id
                  id
                  name
                  created_date
                  updated_date
                }
                language_ids
                languages {
                  _id
                  id
                  name
                  created_date
                  updated_date
                }
              }
            }
  }
`;
export const getSportByCategory = gql`
  query getSportByCategory($id: String!, $channel: Int){
    getSportMediaByCategory(id:$id, channel:$channel){
        id
        name
        img
      }
  }
`;
export const GetSportPagination = gql`
  query getSportPagination($id: String!, $channel: Int, $limit:Int!){
    getSportPagination(id:$id, channel:$channel, limit:$limit){
        id
        name
        img
        created_date
    }
  }
`;

export const broadcastSchedule = gql`
  query broadcastSchedule($channel_slug: String, $date: String) {
    broadcastSchedule(channel_slug: $channel_slug, date: $date) {
      id
      date
      time
      title
      description
      source
      channel_id
    }
  }
`;

export const getCategoriesByTypes = gql`
query getCategoriesByTypes($type: Int) {
  getCategoriesByTypes(type: $type) {
    _id
    id
    name
    created_date
    updated_date

    genre
    slug
    medias {
      id
      name
      sub_name

      nations {
        _id
        id
        name
        created_date
        updated_date
      }

      languages {
        _id
        id
        name
        created_date
        updated_date
      }

      categories {
        id
        _id
        name

        genre
        created_date
        updated_date
      }

      kinds {
        _id
        id
        name
        created_date
        updated_date
      }

      episodesCurent
      episodesMax
      scoreImdb
      img
      created_date
      updated_date
      category_ids
    	kind_ids
      nation_ids
      language_ids
    }
    hot_medias {
      id
      name
      sub_name

      nations {
        _id
        id
        name
        created_date
        updated_date
      }

      languages {
        _id
        id
        name
        created_date
        updated_date
      }

      categories {
        id
        _id
        name

        genre
        created_date
        updated_date
      }

      kinds {
        _id
        id
        name
        created_date
        updated_date
      }


      episodesCurent
      episodesMax
      scoreImdb
      img
      created_date
      updated_date
      category_ids
    	kind_ids
      nation_ids
      language_ids
    }
  }
}
`;

export const getOneCategoryMovie = gql`
query getOneCategoryMovie($type: Int, $_id: ID!, $first: Int, $after: String, $after_hot: String) {
  getOneCategoryMovie(
    type: $type,
    _id: $_id,
    first: $first,
    after: $after,
    after_hot: $after_hot
  ) {
    category {
      _id
      id
      name
      type
      genre
      slug
      created_date
      updated_date
    }

    totalCountMedias
    totalCountHotMedias

    medias {
      id
      name
      sub_name

      nations {
        _id
        id
        name
        created_date
        updated_date
      }

      languages {
        _id
        id
        name
        created_date
        updated_date
      }

      categories {
        id
        _id
        name
        type
        genre
        created_date
        updated_date
      }

      kinds {
        _id
        id
        name
        created_date
        updated_date
      }

      episodesCurent
      episodesMax
      scoreImdb
      img
      created_date
      updated_date
      category_ids
    	kind_ids
      nation_ids
      language_ids
    }

    pageInfoMedias {
      endCursor
      hasNextPage
    }

    hot_medias {
      id
      name
      sub_name

      nations {
        _id
        id
        name
        created_date
        updated_date
      }

      languages {
        _id
        id
        name
        created_date
        updated_date
      }

      categories {
        id
        _id
        name
        type
        genre
        created_date
        updated_date
      }

      kinds {
        _id
        id
        name
        created_date
        updated_date
      }

      episodesCurent
      episodesMax
      scoreImdb
      img
      created_date
      updated_date
      category_ids
    	kind_ids
      nation_ids
      language_ids
    }

    pageInfoHotMedias {
      endCursor
      hasNextPage
    }
  }
}
`;

export const getFooter = gql`
  query getFooter {
    getFooter {
      id
      content
    }
}`;

export const getMoreMoviesByCate = gql`
query getMoreMoviesByCate($category_id: ID!, $cursor: String, $first: Int, $hot_mode: Boolean) {
  getMoreMoviesByCate(
    category_id: $category_id,
    cursor: $cursor,
    first: $first,
    hot_mode: $hot_mode
  ) {
    medias {
      id
      name
      sub_name

      nations {
        _id
        id
        name
        created_date
        updated_date
      }

      languages {
        _id
        id
        name
        created_date
        updated_date
      }

      categories {
        id
        _id
        name
        type
        genre
        created_date
        updated_date
      }

      kinds {
        _id
        id
        name
        created_date
        updated_date
      }

      episodesCurent
      episodesMax
      scoreImdb
      img
      created_date
      updated_date
      category_ids
    	kind_ids
      nation_ids
      language_ids
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
`;

export const channel = gql`
  query channel($slug: String!) {
    channel(slug: $slug) {
      id
      name
      logo
      thumbnail
      source
      description
      type
      slug
      schedule_id
    }
  }
`;

export const channels = gql`
  query channels {
    channels {
      _id
      id
      name
      logo
      thumbnail
      source
      description
      type
      slug
      schedule_id
    }
}`;

export const schedule = gql`
  query schedule($date: String, $channel_id: ID) {
    schedule(date: $date, channel_id: $channel_id)
  }
`;

export const getCategory = gql`
  query getCategory($category_id: ID!){
    getCategory(category_id: $category_id){
      name
      slug
      medias {
        id
      name
      sub_name

      nations {
        _id
        id
        name
        created_date
        updated_date
      }

      languages {
        _id
        id
        name
        created_date
        updated_date
      }

      categories {
        id
        _id
        name
        type
        genre
        created_date
        updated_date
      }

      kinds {
        _id
        id
        name
        created_date
        updated_date
      }
      episodesCurent
      episodesMax
      scoreImdb
      img
      created_date
      updated_date
      category_ids
    	kind_ids
      nation_ids
      language_ids
      }
    }
  }
`;

export const getCategoryAndMediasHot = gql`
  query getCategory($category_id: ID!){
    getCategory(category_id: $category_id){
      name
      slug
      hot_medias {
        id
      name
      sub_name

      nations {
        _id
        id
        name
        created_date
        updated_date
      }

      languages {
        _id
        id
        name
        created_date
        updated_date
      }

      categories {
        id
        _id
        name
        type
        genre
        created_date
        updated_date
      }

      kinds {
        _id
        id
        name
        created_date
        updated_date
      }
      episodesCurent
      episodesMax
      scoreImdb
      img
      created_date
      updated_date
      category_ids
    	kind_ids
      nation_ids
      language_ids
      }
    }
  }
`;

export const getCategoryByGenre = gql`
  query getCategoryByGenre($genre: Int, $type: Int){
    getCategoryByGenre(genre: $genre, type: $type){
      _id
      id
      name
      type
      genre
      slug
      created_date
      updated_date
      }
  }
`;

export const getLanguages = gql`
  query getLanguages {
    getLanguages {
      _id
      id
      name
      created_date
      updated_date
    }
  }
`;

export const getNations = gql`
  query getNations {
    getNations {
      _id
      id
      name
      created_date
      updated_date
    }
  }
`;

export const getItemMedasByFilter = gql`
  query getItemMedasByFilter(
    $form: ID,
    $kind: ID,
    $nation: ID,
    $languages: ID,
    $first: Int,
    $after: String
    ) {
      getItemMedasByFilter(
        form: $form,
        kind: $kind,
        nation: $nation,
        languages: $languages,
        first: $first,
        after: $after
      ) {

        medias {
        id
        name
        sub_name

        nations {
          _id
          id
          name
          created_date
          updated_date
        }

        languages {
          _id
          id
          name
          created_date
          updated_date
        }

        categories {
          id
          _id
          name
          type
          genre
          created_date
          updated_date
        }

        kinds {
          _id
          id
          name
          created_date
          updated_date
        }

        episodesCurent
        episodesMax
        scoreImdb
        img
        created_date
        updated_date
        category_ids
        kind_ids
        nation_ids
        language_ids
      }

      totalCount

      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

export const getAllSinglePage = gql`
query getAllSinglePage {
  getAllSinglePage(visible: true) {
    id
    title
    slug
    visible
    content
    created_date
    updated_date
  }
}`;

export const getSinglePage = gql`
query getSinglePage($id: ID!) {
  getSinglePage (id: $id, visible: true) {
    id
    title
    slug
    visible
    content
    created_date
    updated_date
  }
}`;

export const getSinglePageBySlug = gql`
query getSinglePageBySlug($slug: String!) {
  getSinglePageBySlug (slug: $slug) {
    id
    title
    slug
    visible
    content
    created_date
    updated_date
  }
}`;

export const getMenuFooters = gql`
query getMenuFooters {
  getMenuFooters(visible: true, limit: 6) {
    id
    title
    slug
    visible
    order
  }
}`;

export const getACategory = gql`
query getCategory($category_id:ID!) {
  getCategory(category_id: $category_id) {
    id
    name
    _id
    slug
  }
}`;

export const getCategoryHomeMode = gql`
  query getCategoryHomeMode {
    getCategoryHomeMode {
      _id
      id
      name
      created_date
      updated_date
      type
      genre
      slug
      medias {
        id
        name
        sub_name

        nations {
          _id
          id
          name
          created_date
          updated_date
        }

        languages {
          _id
          id
          name
          created_date
          updated_date
        }

        categories {
          id
          _id
          name
          type
          genre
          created_date
          updated_date
        }

        episodesCurent
        episodesMax
        scoreImdb
        img
        created_date
        updated_date
        category_ids
        nation_ids
        language_ids
      }
    }
  }
`;

export const purchaseDay = gql`
mutation purchaseDay ($user_id: ID!, $package_purchase_day_id: Int) {
  purchaseDay (user_id: $user_id, package_purchase_day_id: $package_purchase_day_id) {
    id
    name
    username
    historiesPucharseDay {
      package_purchase_day {
        id
        day
        scoin
      }
      created_date
    }
    endday
  }
}
`;

export const getPackagePurchaseDay = gql`
query getPackagePurchaseDay {
  getPackagePurchaseDay {
    id
    day
    scoin
  }
}`;

export const purchaseMedia = gql`
mutation purchaseMedia ($user_id: ID!, $media_id: Int){
  purchaseMedia (user_id: $user_id, media_id: $media_id) {
    id
    name
    username
    historiesPucharseMedia {
      media {
        id
        name
        scoin
        nations {
          name
        }
        kinds {
          name
        }
        languages {
          name
        }
      }
      created_date
    }
    medias {
      _id
      id
      name
    }
  }
}
`;

export const purchaseVip = gql`
mutation purchaseVip ($user_id: ID!){
  purchaseVip (user_id: $user_id) {
    id
    name
    username
    is_vip
  }
}
`;

export const findOneOrCreateUser = gql`
  mutation findOneOrCreateUser($userInput: UserInput) {
    findOneOrCreateUser(input: $userInput) {
      id
      name
      fullname
      role
      email
      phone
      avatar
      uniqid
      vietid
      birthday
      address
      status
      endday
      medias {
        _id
        id
        name
      }
      historiesPucharseMedia {
        media {
          id
          name
          scoin
          nations {
            name
          }
          kinds {
            name
          }
          languages {
            name
          }
        }
        created_date
      }
      historiesPucharseDay {
        package_purchase_day {
          day
          scoin
        }
        created_date
      }
      historyPackageDetail {
        package {
          id
          title
        }
        package_detail {
          id
          title
          day
          scoin
        }
        created_date
      }
      is_vip
      user_package {
        id
        endday
        package {
          id
          title
        }
      }
    }
  }
`;

export const getPackages = gql`
query getPackages {
  getPackages {
    id
    title
    description
  }
}`;

export const getPackagesAvailable = gql`
query getPackagesAvailable {
  getPackagesAvailable {
    id
    title
    description
  }
}`;

export const getPackageById = gql`
query getPackageById ($id: ID!) {
  getPackageById(id: $id) {
    id
    title
    description
    base_value
    package_details {
      id
      title
      day
      scoin
      discount {
        id
        title
        percent
        from
        to
      }
    }
  }
}`;

export const purchasePackageDetail = gql`
mutation purchasePackageDetail ($user_id: ID!, $package_detail_id: Int!){
  purchasePackageDetail(user_id: $user_id, package_detail_id: $package_detail_id) {
    id
    name
    fullname
    role
    historyPackageDetail {
      id
      package_detail {
        id
        title
        day
        scoin
      }
      package {
        id
        title
      }
      created_date
    }
    user_package {
      endday
      package {
        title
      }
    }
  }
}
`;



// WEBPACK FOOTER //
// ./src/graphqlDic.js